import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPoint, NavItem } from '@retailer-platform/dashboard/routing'
import { connectOrdersRouter } from './routing/connectOrdersRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import ES_ES from './translations/es-ES.json'
import FR_FR from './translations/fr-FR.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { connectOrdersAccessControl } from './access-control/connectOrdersAccess.configuration'
import { Permission } from './access-control/permissions'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'connect-orders',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'connect-orders-dashboard-tool',
  },
  routes,
  translations: { EN_US, ES_ES, FR_FR },
  routers: {
    scoped: [connectOrdersRouter],
  },
  navigationEntries: [
    {
      attachTo: NavItem.Orders,
      attachToV2: NavEntryPoint.OperationsCustomerSupport,
      subNavItems: [
        {
          type: 'item',
          labelId: 'connectOrdersDomain.orderDetails.lastmiledelivery.title',
          route: 'connect-orders-orders-table',
          accessControl: connectOrdersAccessControl,
          positionNavV2: 2,
          inToolPermissions: [
            {
              slug: Permission.ConnectOrdersModify,
              permissionLabelId:
                'permissionAccordion.permissions.' + Permission.ConnectOrdersModify,
            },
          ],
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
